import React, { Fragment, useEffect, useRef, useState } from "react";
import { Box, CircularProgress, Grid, OutlinedInput } from "@material-ui/core";
import { useStyles } from "./styles";
import navBarLogo from "../../assets/images/navBarLogo.svg";
import { Controller, useForm, useWatch } from "react-hook-form";
import ErrorMessage from "../shared/messages/ErrorMessage";
import Activated from "./Activated";
import { findUniqueCharacter } from "./helpers";
import { withRouter } from "react-router";
import api from "../../store/api";
import { consts } from "../../common/consts";
import { useSelector } from "react-redux";
import { RootState } from '../../store/rootReducer';
const regex = /^[a-zA-Z0-9]+$/;
const inputCount = 8;

const WardConsoleWidget = (): JSX.Element => {
  const classes = useStyles();
  const { authStore } = useSelector((state: RootState) => state);
  const inputsRef = useRef<any>([]);

  const [showActivation, setShowActivation] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [isLoading, setIsLoading] = useState(false);

  // RHF form setup
  const initialFormValues = {
    code: "",
    inputs: ["", "", "", "", "", "", "", ""],
  };
  const { control, reset, setValue, getValues } = useForm({
    defaultValues: initialFormValues,
  });
  const inputValues = useWatch<string[]>({ name: "inputs", control });

  const activateNext = () => {
    reset(initialFormValues);
    setShowActivation(false);
  };

  // handle input changes & focus to next field
  const handleInputChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    index: number
  ) => {
    if (!regex.test(e.target.value)) return;

    let prevState = getValues(e.target.name);

    let newValue = findUniqueCharacter(prevState, e.target.value);
    setValue(e.target.name, newValue?.toUpperCase());

    inputsRef.current[index === inputCount ? inputCount - 1 : index].focus();
  };

  // handle backspace events & focus to prev field
  const handleKeydown = (
    e: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>,
    value: string,
    index: number
  ) => {
    if (e.key === "Backspace") {
      setValue(`inputs[${index}]`, "");
      value?.length === 0 &&
        inputsRef.current[index ? index - 1 : index].focus();
    }
  };

  // handle onsubmit
  const handleOnSubmit = async (code: string) => {
    setErrorMessage("");
    setIsLoading(true);
    try {
      const res = await api.updateactivationcode("activationCode=" + code);
      if (res.hasError === false) {
        setShowActivation(true);
      } else if (
        res.hasError === true &&
        res.message === "Error: Unauthorized user"
      ) {
        setErrorMessage("The user is not allowed to perform this task");
        setShowActivation(false);
      } else {
        setErrorMessage("The activation code is not valid.");
        setShowActivation(false);
      }
      setIsLoading(false);
    } catch (error) {
      setErrorMessage("The activation code is not valid.");
      setIsLoading(false);
    }
  };
  // watch for all input fields are entered & to trigger api
  useEffect(() => {
  const code = inputValues?.join("");
  if (code?.length === inputCount) {
    handleOnSubmit(code);
  }
}, [inputValues]);
  return (
    <Box className={classes.root}>
      <Grid container spacing={0} className={classes.main}>
        <Grid item xs={12} sm={"auto"} className={"mainContent"}>
          <div className={"logoSec"}>
            <img src={navBarLogo} alt="" className={"logo"} />
          </div>
          <div className={"mainSec"}>
            <div className={"title"}>WARD CONSOLE ACTIVATION</div>
            {showActivation ? (
              <Activated activateNext={activateNext} />
            ) : (
              <div className={"formSec"}>
                <form onSubmit={(e) => e.preventDefault()} autoComplete="off">
                  <div className={"formLabel"}>
                    Enter the code displayed on your TV
                  </div>
                  <div className={"formField"}>
                    {[...Array(inputCount)]?.map((input: string, i: number) => {
                      return (
                        <Fragment key={`input-${i + 1}`}>
                          {i === inputCount / 2 && (
                            <div className={"codeDivider"}>-</div>
                          )}
                          <Controller
                            control={control}
                            name={`inputs[${i}]`}
                            render={({ name, value }) => (
                              <OutlinedInput
                                name={name}
                                value={value}
                                onChange={(e) => handleInputChange(e, i + 1)}
                                inputRef={(el) => (inputsRef.current[i] = el)}
                                className={"codeInput"}
                                onKeyDown={(e) => handleKeydown(e, value, i)}
                              />
                            )}
                          />
                        </Fragment>
                      );
                    })}
                  </div>
                </form>
              </div>
            )}
            {errorMessage && <ErrorMessage errorMessage={errorMessage} />}
            {isLoading && (
              <Box className="loader">
                <CircularProgress color="inherit" size={24} />
              </Box>
            )}
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default React.memo(withRouter(WardConsoleWidget));
